import api from './api';

const pinnedTemplateSetService = {
    /**
     * Get all pinned template sets for the authenticated user
     * @returns {Promise<Array>} Array of pinned template sets
     */
    getPinnedTemplateSets: async () => {
        const response = await api.get('/api/pinned-template-sets');
        return response;
    },

    /**
     * Pin a template set
     * @param {number} templateSetId - Template Set ID to pin
     * @returns {Promise<Object>} Pinned template set data
     */
    pinTemplateSet: async (templateSetId) => {
        const response = await api.post('/api/pinned-template-sets', { templateSetId });
        return response;
    },

    /**
     * Unpin a template set
     * @param {number} templateSetId - Template Set ID to unpin
     * @returns {Promise<void>}
     */
    unpinTemplateSet: async (templateSetId) => {
        const response = await api.delete(`/api/pinned-template-sets/${templateSetId}`);
        return response;
    },

    /**
     * Toggle pin status of a template set
     * @param {number} templateSetId - Template Set ID to toggle
     * @returns {Promise<Object>} Result with isPinned status
     */
    togglePin: async (templateSetId) => {
        const response = await api.post('/api/pinned-template-sets/toggle', { templateSetId });
        return response;
    },

    /**
     * Reorder pinned template sets
     * @param {Array<{id: number, order: number}>} items - Array of {id, order} objects
     * @returns {Promise<void>}
     */
    reorderPinnedTemplateSets: async (items) => {
        const response = await api.put('/api/pinned-template-sets/reorder', { items });
        return response;
    },
};

export default pinnedTemplateSetService;
